import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useCallback } from "react";
import { useQuery } from "react-query";
import { IRunTicketModel } from "../../services/run-tickets-data-service/Models";
import RunTicketsDataService from "../../services/run-tickets-data-service/RunTicketsDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { UseRunTicketsOptionsType, UseRunTicketsReturnType, selectRunTickets } from "./Common";
import { keys } from "./Keys";

export type UseRunTicketsParameters = {
    customerID: number,
    groupID: number,
    contextObject: IeLynxObject,
    timestamp: Date,
    options?: UseRunTicketsOptionsType,
} & BaseUseQueryParameters<UseRunTicketsReturnType>;

export function useRunTickets({
    customerID,
    groupID,
    contextObject,
    timestamp,
    options,
    offline,    
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseRunTicketsParameters) {
    return useQuery<Array<IRunTicketModel>, RestError, UseRunTicketsReturnType>(
        keys.list(customerID, groupID, contextObject, offline ?? false, timestamp),
        ({ signal }) => {
            return RunTicketsDataService.getRunTickets(customerID, groupID, contextObject, offline ?? false, timestamp, signal);
        },
        {
            select: useCallback(
                (data: Array<IRunTicketModel>) => selectRunTickets(data, options),
                [options]
            ),
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
